import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// Custom
import axios from "axios";
import VueAxios from "vue-axios";

import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

createApp(App).use(store).use(router).use(VueAxios, axios).mount("#app");
